/**
 * Button Click Handlers
 *
 * Attaches click event listeners to buttons with GTM tracking data
 * and pushes events to the dataLayer.
 *
 * Only event-specific parameters (from data attributes) are included.
 * Global and post parameters are NOT included (only used in pageview event).
 *
 * =============================================================================
 * TAB CONTENT
 * =============================================================================
 *
 * When tabs switch content, new buttons may appear that weren't in DOM during
 * initial page load. We listen for 'awc-after-tab-update' to attach handlers
 * to any new buttons. We use a data attribute marker to skip buttons that
 * already have handlers attached.
 */

import { gtmLog, gtmError } from './gtm-logger';

/**
 * Attach click handler to a button.
 *
 * @param {HTMLElement} button The button element.
 */
const handleGtmButtonClick = ( { target } ) => {
	const button = target?.closest?.( 'a[href], button' );

	if (
		! button ||
		! button.hasAttribute( 'data-gtm-params' ) ||
		'true' === button.getAttribute( 'aria-expanded' )
	) {
		return;
	}

	let eventParams = {};
	try {
		eventParams = JSON.parse( button.dataset.gtmParams );
	} catch ( error ) {
		gtmError( `Failed to parse "${ button.dataset.gtmEvent }" event parameters:`, error );
		return;
	}

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push( eventParams );

	gtmLog( 'Button click:', eventParams );
};

// one global event listener to /rule them all/ eliminate the need to
// 		- track if listener was attached or not;
// 		- add listeners on every tab change.
document.addEventListener( 'click', handleGtmButtonClick, { capture: true } );
